import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  rawMaterials: [],
  stocks: [],
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveStock: ['stock', 'onSuccess', 'onError'],
  removeStock: ['stock', 'onSuccess', 'onError'],
  stockError: ['error'],
  saveRawMaterial: ['rawMaterial', 'onSuccess', 'onError'],
  removeRawMaterial: ['rawMaterial', 'onSuccess', 'onError'],
  rawMaterialError: ['error']
})

const saveStock = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeStock = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const stockError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const saveRawMaterial = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeRawMaterial = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const rawMaterialError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.STOCK_ERROR]: stockError,
  [Types.SAVE_STOCK]: saveStock,
  [Types.REMOVE_STOCK]: removeStock,

  [Types.RAW_MATERIAL_ERROR]: rawMaterialError,
  [Types.SAVE_RAW_MATERIAL]: saveRawMaterial,
  [Types.REMOVE_RAW_MATERIAL]: removeRawMaterial,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as RawMaterialsStocksTypes,
  Creators as RawMaterialsStocksActions
}
